<template>
  <CrudForm
    :title="title"
    :labelSubmit="labelSubmit"
    :storeName="storeName"
    :parentStoreName="parentStoreName"
    :parentUrlKey="parentUrlKey"
    :submit="submit"
    :status="status"
    labelBack="Atrás"
  >
    <ValidationObserver ref="validator" v-slot="{}">
      <v-row justify="center">
        <v-col cols="8">
          <v-row>
            <v-col>
              <ValidationProvider
                  ref="day"
                  rules="required"
                  v-slot="{ errors }"
              >
                <v-select
                    :error-messages="errors"
                    v-model="data.day"
                    label="Día"
                    :items="days"
                >
                  <template slot="no-data">
                    <v-alert :value="true"> No hay datos a mostrar </v-alert>
                  </template>
                </v-select>
              </ValidationProvider>
            </v-col>
            <v-col>
              <ValidationProvider
                      ref="availability"
                      rules="required"
                      v-slot="{ errors }"
              >
                <v-select
                        :error-messages="errors"
                        v-model="data.availability"
                        label="Disponibilidad"
                        :items="availabilities"
                >
                  <template slot="no-data">
                    <v-alert :value="true"> No hay datos a mostrar </v-alert>
                  </template>
                </v-select>
              </ValidationProvider>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-btn class="btn btn-seconday" @click="change_hours()">
                Añadir horario
              </v-btn>
            </v-col>
            <v-col>
              <v-row>
                <v-col>
                  <h3 class="mb-3">Horarios</h3>
                  <p v-for="(available_hour,index) of data.available_hour" :key="index">{{available_hour.hour_from}} - {{available_hour.hour_to}}</p>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <ValidationProvider
                  ref="hour_from"
                  :rules="rules_hours"
                  v-slot="{ errors }"
              >
                <v-text-field
                :error-messages="errors"
                v-model="hours.hour_from"
                type="time"
                label="Desde"
              ></v-text-field>
              </ValidationProvider>
            </v-col>
            <v-col>
              <ValidationProvider
                  ref="hour_to"
                  :rules="rules_hours"
                  v-slot="{ errors }"
              >
                <v-text-field
                :error-messages="errors"
                v-model="hours.hour_to"
                type="time"
                label="Hasta"
              ></v-text-field>
              </ValidationProvider>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </ValidationObserver>
  </CrudForm>
</template>

<script>
  import {ValidationProvider, ValidationObserver} from "vee-validate";
  import {mapState} from 'vuex';
  import Upload from "@/components/Upload";
  import CrudForm from "@/components/Crud/CrudForm";
  import CrudFormMixin from '@/mixins/crud_form';

  export default {
    mixins: [CrudFormMixin],
    components: {ValidationProvider, ValidationObserver, CrudForm, Upload},
    computed: {
      ...mapState({
        status: state => state.Available_days.status,
      })
    },
    async created() {
      const self = this;
      let filters = {};

      if(this.$route.params.spot_id) {
        this.data.spot_id = this.$route.params.spot_id
        filters.spot_id = this.$route.params.spot_id
      }

    },
    data() {
      return {
        parentStoreName: 'Users_scroll/'+this.$route.params.user_id+'/Spots',
        parentUrlKey:"spot_id",
        storeName: 'Available_days',
        title: "Días disponibles",
        days: ['Lunes','Martes','Miercoles','Jueves','Viernes','Sabado','Domingo'],
        availabilities: ['full_time', 'part_time', 'my_time'],
        data: {
          spot_id: '',
          day: '',
          availability: '',
          available_hour: [],
        },
        hours: {
          hour_from:'',
          hour_to:'',
        },
        rules_hours:'',
      }
    },  
    methods: {
        change_hours(){
          const self = this;
          let valid = this.validate_hours();
          if(valid){
            let hour = {
              hour_from: this.hours.hour_from,
              hour_to: this.hours.hour_to
            }
            this.data.available_hour.push(hour)
            this.hours.hour_from = '';
            this.hours.hour_to = '';
          }else{
            setTimeout(() => {
              self.set_rules_hours('');
            }, 1000);
          }
        },
        validate_hours(){
          if(this.hours.hour_from != '' && this.hours.hour_to != ''){
            return true;
          }else{
            this.set_rules_hours('required');
            this.$refs.hour_from.validate();
            this.$refs.hour_to.validate();
            return false;
          }
        },
        set_rules_hours(val){
          this.rules_hours = val
        }
    },
  }
</script>
